// extracted by mini-css-extract-plugin
export default {"amount":"Cart_amount__WkKsQ","button-group":"Cart_button-group__Pocal","items":"Cart_items__OHHu4","empty":"Cart_empty__IMCxO"};